import styled from 'styled-components'
import { LookButton, iconButtonLook } from 'components/Buttons/look'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: #FFFFFF;
  border-radius: 10px;
  box-shadow: 0px 2px 10px -6px #252525;
  padding: 15px;
  gap: 15px;
`

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: -7px;
  margin-right: -7px;
`

export const Image = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 10px;
`

export const Info = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
`

export const InfoText = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  margin: 0px;
`

export const SubTitle = styled(InfoText)`
  font-size: 16px;
  font-weight: 500;
`

export const Description = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #444444;
  margin: 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const MoneyTextMask = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0px;
  padding: 0px;
`

export const Button = styled(LookButton).attrs(iconButtonLook())`
  width: 32px;
  height: 32px;
`
